export default __webpack_public_path__ + "static/media/icon-1.fc98c7c5.png";